import {ActionRecordModel, ActionTypeModel} from "../actions";
import {ListModel, PaginationQueryModel} from "../common";

export enum AssistantActionAttachmentTypeModel {
  BEFORE = "before",
  DURING = "during",
  AFTER = "after",
}

export type AssistantActionRecordModel = {
  id: string;
  name: string;
  type: ActionTypeModel;
  attachmentType: AssistantActionAttachmentTypeModel;
  results?: string[]; // Optional property for action results (array of strings)
};

export type AssistantActionListQueryModel = PaginationQueryModel & {
  attachmentType?: AssistantActionAttachmentTypeModel;
};

export type AssistantActionListModel = ListModel<AssistantActionRecordModel> & {
  counts: {
    attachmentType: Record<AssistantActionAttachmentTypeModel, number>;
  };
};

export type BatchAttachActionModel = {
  items: {
    id: ActionRecordModel["action_id"];
    attachmentType: AssistantActionAttachmentTypeModel;
  }[];
};
